<template>
  <canvas
    class="block w-full h-full"
    :class="prePhase ? 'p-0' : 'px-2 py-1'"
    ref="visualizer"
    :width="width"
    :height="height"
  ></canvas>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  props: {
    stream: {
      type: MediaStream,
      required: true,
    },
    width: {
      type: Number,
      default: 320,
    },
    height: {
      type: Number,
      default: 170,
    },
    prePhase: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const visualizer = ref(null);
    let audioContext;
    let analyser;
    let dataArray;
    let animationFrame;

    onMounted(() => {
      const canvas = visualizer.value;
      const canvasCtx = canvas.getContext('2d');

      audioContext = new (window.AudioContext || window.webkitAudioContext)();
      analyser = audioContext.createAnalyser();
      const source = audioContext.createMediaStreamSource(props.stream);
      const gainNode = audioContext.createGain();
      gainNode.gain.setValueAtTime(5, audioContext.currentTime);
      source.connect(gainNode);
      gainNode.connect(analyser);

      analyser.fftSize = 4096;
      analyser.smoothingTimeConstant = 0.85;
      analyser.minDecibels = -120;
      analyser.maxDecibels = -60;

      const bufferLength = analyser.frequencyBinCount;
      dataArray = new Uint8Array(bufferLength);

      function draw() {
        animationFrame = requestAnimationFrame(draw);

        analyser.getByteTimeDomainData(dataArray);

        canvasCtx.fillStyle = '#1a3b47';
        canvasCtx.fillRect(0, 0, props.width, props.height);

        canvasCtx.lineWidth = 2;
        canvasCtx.strokeStyle = 'rgb(255, 255, 255)';
        canvasCtx.beginPath();

        const sliceWidth = props.width / bufferLength;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
          const v = dataArray[i] / 128.0;
          const y = (v * props.height) / 2;

          if (i === 0) {
            canvasCtx.moveTo(x, y);
          } else {
            canvasCtx.lineTo(x, y);
          }

          x += sliceWidth;
        }

        canvasCtx.lineTo(props.width, props.height / 2);
        canvasCtx.stroke();
      }

      draw();
    });
    onUnmounted(() => {
      clearInterval(animationFrame);
      if (audioContext) {
        audioContext.close();
      }
    });

    return { visualizer };
  },
};
</script>

<style scoped></style>
